module.exports = __webpack_public_path__ + "static/media/logo.539bf01b.svg";